module.exports = __webpack_public_path__ + "img/en.13700d16.svg";